module.exports = __webpack_public_path__ + "assets/img/1265.2ea3f9e0.png";